const Error = () => <div className="error">Error</div>;

export default Error;
